const searchMapdots = {
  a1b2c3: "title",
  d4e5f6: "address",
  g7h8i9: "city",
  j0k1l2: "country",
  m3n4o5: "phoneNr",
  n6o7p8: "emailMapdot",
  q9r0s1: "website",
  t2u3v4: "price",
  w5x6y7: "day",
  z8a9b0: "categoryIdName",
  c1d2e3: "coordinatesLatLong",
  f4g5h6: "cityObject",
  i7j8k9: "_id",
  l0m1n2: "dateStart",
  o3p4q5: "dateEnd",
  r6s7t8: "dateOnce",
  u9v0w1: "isMapdotConfirmed",
};

const searchCities = {
  a1b2c3: "cityName",
  d4e5f6: "coordinatesLatLongCity",
  i7j8k9: "_id",
};

const PREFIX = "bailo.app_property_";
const SUFFIX = "_copyright";

function deobfuscate(data, mapping) {
  return data.map((item) => {
    const result = {};
    Object.keys(item).forEach((key) => {
      const originalKey = mapping[key] || key;
      const rawValue = item[key];
      const value =
        typeof rawValue === "string" &&
        rawValue.startsWith(PREFIX) &&
        rawValue.endsWith(SUFFIX)
          ? rawValue.slice(PREFIX.length, rawValue.length - SUFFIX.length)
          : rawValue;

      result[originalKey] = value;
    });
    return result;
  });
}

export function deobfuscateSearchMapdots(data) {
  return deobfuscate(data, searchMapdots);
}

export function deobfuscateSearchCities(data) {
  return deobfuscate(data, searchCities);
}

